<div class="flex flex-col min-w-64 max-w-96 gap-4 p-4 items-center">
    <div class="flex flex-col items-center justify-center w-full text-center">
        <div class="icon-wrapper w-16 h-16 rounded-full flex items-center justify-center mb-6">
            <mat-icon
                class="icon w-full h-full text-4xl leading-none"
                [ngClass]="'text-' + (data.icon.color || 'error') + '-500'"
                [svgIcon]="data.icon.name || 'heroicons_outline:exclamation'"
            >
                warning
            </mat-icon>
        </div>

        <div class="title" [innerHTML]="data.title"></div>

        <div class="message" [innerHTML]="data.message"></div>
    </div>

    <div class="flex flex-col items-center w-full px-8 sm:px-10 gap-4">
        <v2-button-wrapper
            *ngIf="data.actions.confirm.show"
            [color]="data.actions.confirm.color || 'primary'"
            text="{{ data.actions.confirm.label }}"
            variant="raised"
            class="w-full md:w-48"
            [classes]="'w-full md:w-48'"
            (click)="matDialogRef.close('confirmed')"
        ></v2-button-wrapper>

        <v2-button-wrapper
            *ngIf="data.actions.cancel.show"
            [variant]="'flat'"
            [color]="data.actions.cancel.color || 'neutral'"
            text="{{ data.actions.cancel.label }}"
            class="w-full md:w-48"
            [classes]="'w-full md:w-48'"
            (click)="matDialogRef.close('cancelled')"
        ></v2-button-wrapper>

        <v2-button-wrapper
            *ngIf="data.actions.discard.show"
            [variant]="'flat'"
            [color]="data.actions.discard.color || 'warn'"
            text="{{ data.actions.discard.label }}"
            class="w-full md:w-48"
            [classes]="'w-full md:w-48'"
            (click)="matDialogRef.close('discard')"
        ></v2-button-wrapper>
    </div>
</div>
